import { Link } from "react-router-dom";
import { ArrowRight, MessageSquare, ClipboardList, Sparkles } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { CtaBand } from "../components/CtaBand";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        label="About Us"
        title="Local flooring supply and installation, done properly"
        testId="about-header"
      />

      <section className="py-20 md:py-24" data-testid="about-intro">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-base md:text-lg text-[#1C1C1C] leading-relaxed" data-testid="about-intro-text">
              Zum Flooring provides quality hybrid flooring supply and installation services across Melbourne.
              We focus on reliable service, clear communication and clean workmanship. Whether you need flooring
              supplied, installed or both, we can help you find a practical option that suits your home and budget.
            </p>
            <p className="mt-5 text-base text-[#525252] leading-relaxed">
              We keep things simple: you tell us what your home needs, we give you a clear written quote, and we
              turn up and do the job properly. No pushy sales talk and no surprises on the invoice.
            </p>
          </div>
          <div className="rounded-2xl overflow-hidden border border-[#E5E5E5]">
            <img
              src="https://images.unsplash.com/photo-1560185008-b033106af5c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwdGltYmVyJTIwZmxvb3Jpbmd8ZW58MHx8fHwxNzg3MjI0NDQwfDA&ixlib=rb-4.1.0&q=85"
              alt="Timber flooring in a modern Australian home interior"
              className="w-full h-full object-cover aspect-[4/3]"
              data-testid="about-image"
            />
          </div>
        </div>
      </section>

      <section className="bg-[#FAFAFA] py-20 md:py-24" data-testid="about-values">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl sm:text-4xl tracking-tight font-semibold">What you can expect from us</h2>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                icon: MessageSquare,
                title: "Clear communication",
                text: "You will always know what is included, what it costs and when we can start. Plain answers, no jargon.",
              },
              {
                icon: ClipboardList,
                title: "Reliable service",
                text: "We check your subfloor before quoting, confirm the details in writing and show up when we say we will.",
              },
              {
                icon: Sparkles,
                title: "Clean workmanship",
                text: "Accurate cuts, neat scotia lines and a tidy home when we leave. The finish matters as much as the floor.",
              },
            ].map((v, i) => (
              <div key={v.title} className="border border-[#E5E5E5] rounded-xl p-8 bg-white fade-up" style={{ animationDelay: `${i * 80}ms` }} data-testid={`about-value-${i}`}>
                <v.icon className="w-7 h-7 text-[#C87A38]" />
                <h3 className="mt-4 text-lg font-semibold font-heading">{v.title}</h3>
                <p className="mt-2 text-sm text-[#525252] leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
          <div className="mt-12">
            <Link
              to="/get-a-free-quote"
              className="inline-flex items-center gap-2 rounded-full bg-[#C87A38] px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-[#A6632B] focus:outline-none focus:ring-2 focus:ring-[#C87A38] focus:ring-offset-2"
              data-testid="about-quote-button"
            >
              Get a Free Quote <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
